/*
 * App Router version of `../validateOrderHandler`.
 */
import { NextResponse, type NextRequest } from 'next/server'
import { setRequestLocale } from '../../../common/api/setRequestLocale'
import { routeHandlerWithLogging } from '../../../logging/routeHandlerWithLogging'
import { qliroValidateOrder } from './qliroValidateOrder'
import { type ValidateOrderHandlerOpts } from './types'

export const validateOrderRouteHandler = (opts?: ValidateOrderHandlerOpts) =>
  routeHandlerWithLogging(async function POST(request: NextRequest) {
    setRequestLocale(request)

    const orderId = request.nextUrl.searchParams.get('order_id')

    if (!orderId) {
      return NextResponse.json({ error: 'Missing query params.' }, { status: 400 })
    }

    switch (opts?.paymentProviderConfig?.providerName ?? 'KLARNA') {
      case 'QLIRO':
        return qliroValidateOrder({
          orderId,
          shippingProviderName: opts?.shippingProviderConfig?.provider
        })
      default:
        // No validation callback for the other providers — they never call this
        // endpoint, and a success keeps any stray caller unblocked.
        return NextResponse.json({ success: true })
    }
  })
